exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".action {\n  height: 48px;\n  width: 100%;\n  padding: 0 10px;\n  -ms-flex-align: center;\n      align-items: center; }\n\n.visibility-hidden {\n  visibility: hidden; }\n\n.child-items {\n  overflow: hidden;\n  max-height: 0; }\n\n.child-items.expanded {\n  max-height: unset !important; }\n\n.expand-icon {\n  padding: 0 5px;\n  font-size: 25px;\n  width: 20px;\n  color: #1d1d1d; }\n\n.expand-icon:hover {\n  color: #4b81b0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/abm/permisos-detail/action/action.component.scss
// module id = ../../../../../src/app/components/abm/permisos-detail/action/action.component.scss
// module chunks = 0